import React from 'react';
import './App.css';

const App = () => {
  return (
    <div>
      Work in progress
    </div>
  );
}

export default App;
